import reservationUtils from "@/utils/reservationUtils";
import { hideAllOffcanvas, hideAllModals } from "@/utils";
import store from "@/store/index";
import { reservationRepository } from "@/service/repository/reservationRepository";

const state = () => ({
	reservation: null,

	isUpdateMethodPayment: false,

	statusStart: 1,
	statusNoShow: -4,
	statusForPayment: 7,
});

const getters = {
	reservation: (state) => state.reservation,

	isUpdateMethodPayment: (state) => {
		return state.isUpdateMethodPayment;
	},

	totalPrice: (state) => {
		if (!state.reservation || !state.reservation.paymentInfo) {
			return "0,00";
		}
		return state.reservation.paymentInfo.total.toFixed(2).replace(".", ",");
	},

	getTickets: (state) => {
		return reservationUtils.getBills(state.reservation);
	},
	getInvoices: (state) => {
		return reservationUtils.getSimplifiedInvoices(state.reservation);
	},
};

const mutations = {
	setReservation: (state, reservation) => {
		state.reservation = reservation;
	},
	setIsUpdateMethodPayment: (state, isUpdateMethodPayment) => {
		state.isUpdateMethodPayment = isUpdateMethodPayment;
	},
};

const actions = {
	updateReservation({ commit }, reservation) {
		commit("setReservation", reservation);
	},

	async processPaymentPending(_, { reservationId, methodPayment, uid, selectedRole }) {
		try {
			const resultRequestTicket = await reservationRepository.setPaymentPending(reservationId, methodPayment, uid, selectedRole);

			if (resultRequestTicket.result === 0) {
				hideAllOffcanvas();
			} else {
				await store.dispatch("copilot/showToastError", {
					message: `No se ha podido marcar el método de pago`,
				});
			}
			return resultRequestTicket;
		} catch (error) {
			console.error("Error en el pago:", error);
			await store.dispatch("copilot/showToastError", {
				message: `Error en el pago: ${error.message}`,
			});
		}
	},

	async reactivateReservation(_, reservationId) {
		try {
			const resultReactivateReservation = await reservationRepository.reactivateReservation(reservationId);

			if (resultReactivateReservation.result === 0) {
				hideAllOffcanvas();
			} else {
				await store.dispatch("copilot/showToastError", {
					message: `No se ha podido reactivar la cuenta.`,
				});
			}
		} catch (error) {
			console.error("Error al reactivar la reserva:", error);
			await store.dispatch("copilot/showToastError", {
				message: `Error al reactivar la reserva: ${error.message}`,
			});
		}
	},

	async paidReservation({ commit, dispatch }, data) {
		try {
			const resultPaidReservation = await reservationRepository.paidReservation(data);

			if (resultPaidReservation.result === 0) {
				hideAllModals();
				if (resultPaidReservation.bill && resultPaidReservation.bill.id) {
					await dispatch("weWingman/printBill", resultPaidReservation.bill, { root: true });
				}
				commit("setIsUpdateMethodPayment", false);
				commit("setReservation", null);
			} else {
				await store.dispatch("copilot/showToastError", {
					message: `No se ha podido marcar la cuenta como pagada`,
				});
			}

			return resultPaidReservation;
		} catch (error) {
			console.error("Error al pagar la reserva:", error);

			await store.dispatch("copilot/showToastError", {
				message: `Error al pagar la reserva: ${error.message}`,
			});

			return { result: -1, error };
		}
	},

	async updatePaxReservation(_, { reservationId, numberPax }) {
		try {
			const data = {
				reservationWid: reservationId,
				pax: numberPax,
			};
			const resultUpdatedPaxReservation = await reservationRepository.updatePax(data);

			if (resultUpdatedPaxReservation.result === 0) {
				hideAllModals();
			} else {
				await store.dispatch("copilot/showToastError", {
					message: `Ha ocurrido un error actualizando los comensales`,
				});
			}

			return resultUpdatedPaxReservation;
		} catch (error) {
			console.error("Error al actualizar las personas en la reserva:", error);

			await store.dispatch("copilot/showToastError", {
				message: `Error al actualizar las personas en la reserva: ${error.message}`,
			});

			return { result: -1, error };
		}
	},
	openCreateInternalComment({ commit }, reservation) {
		commit("setReservation", reservation);
		store.dispatch('uiOverlay/setIsShowOverlayInternalComment',true)
	},

	openPaidAccount({ commit }, reservation) {
		commit("setReservation", reservation);
		commit("setIsUpdateMethodPayment", true);

		store.dispatch("uiOverlay/setIsShowOverlayFinishAccount", true);

		// setTimeout(() => {
		// 	showModal("confirm-close-" + reservation.id);
		// });
	},
	openFinishReservation({ commit }, reservation) {
		commit("setReservation", reservation);
		store.dispatch("uiOverlay/setIsShowOverlayFinishAccount", true);

		/*	setTimeout(() => {
				showModal("confirm-close-" + reservation.id);
			});*/
	},

	async createTipToReservation(_, { reservationId, tip }) {
		try {
			const data = {
				reservationId: reservationId,
				tipInfo: tip,
			};
			const response = await reservationRepository.createTipToReservation(data);

			if (response.result === 0) {
				await store.dispatch("copilot/showToastSuccess", {
					message: `Se ha agregado correctamente la propina`,
				});
				hideAllModals();
			} else {
				await store.dispatch("copilot/showToastError", {
					message: `Ha ocurrido un error agregando la propina`,
				});
			}
			return response.result;
		} catch (error) {
			console.error("Error al crear la propina:", error);
			await store.dispatch("copilot/showToastError", {
				message: `Ha ocurrido un error con el servidor`,
			});
			throw error;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
